// Single source of truth for the Contentstack connection.
//
// We pass only CONTENTSTACK_API_KEY (public) and CONTENTSTACK_DELIVERY_TOKEN
// (secret). The environment is derived from APPLICATION_ENVIRONMENT — the
// standard variable every Mapped service running on Kubernetes sets ("Dev" /
// "Prod"). The rest of the GraphQL URL is hardcoded here.

export const environment: 'development' | 'production' =
  process.env.APPLICATION_ENVIRONMENT?.toLowerCase() === 'prod'
    ? 'production'
    : 'development';

export const apiKey = process.env.CONTENTSTACK_API_KEY as string;

export const contentStackGraphqlUri = `https://graphql.contentstack.com/stacks/${apiKey}?environment=${environment}`;

// Upper bound on how long any cached Contentstack response may be served.
// Contentstack's CDN caches GraphQL responses with max-age=1y and relies on
// publish-triggered invalidation, which is unreliable for queries with nested
// references — so published changes could stay invisible until a pod restart.
export const CONTENT_TTL_MS = 60_000;

// Returns the GraphQL endpoint with a time-bucketed cache-busting parameter.
// The bucket changes every CONTENT_TTL_MS, giving each new bucket a fresh CDN
// cache key — published content goes live within that window, and within a
// bucket Contentstack's CDN still serves cached (fast) responses.
export const contentStackGraphqlFreshUri = () =>
  `${contentStackGraphqlUri}&fresh=${Math.floor(Date.now() / CONTENT_TTL_MS)}`;
